import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmedValidator } from '../confirmed.validator';
import { UtilitaService } from '../services/utilita.service';
//import { Md5 } from "md5-typescript"; non trova md5
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Md5 } from 'md5-typescript';

@Component({
  selector: 'app-accedi',
  templateUrl: './accedi.component.html',
  styleUrls: ['./accedi.component.css']
})
export class AccediComponent implements OnInit {
  

  constructor(private fb: FormBuilder,
    private srvUtilita: UtilitaService, public authService: AuthService,
    private dialog: MatDialog, private router: Router,
    private snackBar: MatSnackBar) { }

  ngOnInit(): void {


  }
}
